import { Link } from 'react-router-dom'
import Seo from '@/components/Seo'
import SiteLayout from '@/components/SiteLayout'
import PageHero from '@/components/PageHero'
import CtaBand from '@/components/CtaBand'
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { features, featuresHub } from '@/content/features'
import { cardImageOf, heroImageOf } from '@/content/applyImages'

export default function FeaturesHubPage() {
  return (
    <SiteLayout>
      <Seo
        title={featuresHub.seoTitle}
        description={featuresHub.seoDescription}
        path={featuresHub.path}
        image={heroImageOf(featuresHub)}
      />
      <PageHero
        title={featuresHub.title}
        description={featuresHub.description}
        image={heroImageOf(featuresHub)}
        eyebrow="Product"
      />
      <section className="py-16 bg-background">
        <div className="container mx-auto max-w-7xl px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature) => (
              <Link key={feature.slug} to={feature.path} className="block group">
                <Card className="h-full overflow-hidden hover:shadow-lg transition-shadow">
                  <div className="h-48 overflow-hidden">
                    <img
                      src={cardImageOf(feature)}
                      alt={feature.title}
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    />
                  </div>
                  <CardHeader>
                    <CardTitle>{feature.title}</CardTitle>
                    <CardDescription>{feature.hubDescription}</CardDescription>
                  </CardHeader>
                </Card>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <CtaBand
        title="See Tillio in your restaurant"
        description="Tell us about your business and we’ll help you get set up."
      />
    </SiteLayout>
  )
}
